import {Icon, DefaultButton, TextField} from '@fluentui/react';
import {useState} from 'react';
import {formatDateGerman} from '../../common/dateFormatting';
import {Subscription} from '../../Swagger/api';
import styles from './subscriptions.module.scss';
import {CancelSubscription} from './cancelSubscription';
import {ChangeMaxUsers} from './changeMaxUsers';
import {ExtendSubscription} from './extendSubscription';
import {ManageDomains} from './manageDomains/manageDomains';
import {RegisteredUsers} from './registeredUsers/registeredUsers';
import {ResetSubscription} from './resetSubscription';

interface IPerUserSubscription {
  subscription: Subscription;
  onReload: () => void;
}

export const PerUserSubscription = (props: IPerUserSubscription) => {
  const [subscriptionManageDomainsOpen, setSubscriptionManageDomainsOpen] =
    useState(false);
  const [subscriptionRegisteredUserOpen, setSubscriptionRegisteredUserOpen] =
    useState(false);
  const [resetSubscriptionOpen, setResetSubscriptionOpen] = useState(false);
  const [removeSubscriptionOpen, setRemoveSubscriptionOpen] = useState(false);
  const [extendSubscriptionOpen, setExtendSubscriptionOpen] = useState(false);
  const [changeMaxUsersOpen, setChangeMaxUsersOpen] = useState(false);

  return (
    <article
      className={`${styles.subscriptionContainer} per-user subscription-item`}
    >
      <section className={styles.title}>
        <strong>
          {props.subscription.product ? props.subscription.product.name : ''}
        </strong>{' '}
        - Per user subscription
        <Icon className={styles.icon} iconName="FollowUser" />
      </section>
      <section className={styles.container}>
        <TextField
          label="Date started"
          readOnly
          value={
            props.subscription.start
              ? formatDateGerman(props.subscription.start)
              : ''
          }
        />
        <TextField
          label="Users registered"
          readOnly
          value={
            props.subscription.registeredUsers
              ? props.subscription.registeredUsers.length.toString()
              : '0'
          }
        />
      </section>
      <section className={styles.container}>
        <TextField
          label="Expiration date"
          readOnly
          value={
            props.subscription.expiration
              ? formatDateGerman(props.subscription.expiration)
              : ''
          }
        />
        <TextField
          label="Maximum users"
          readOnly
          value={
            props.subscription.maxUsers
              ? props.subscription.maxUsers.toString()
              : '0'
          }
        />
      </section>
      <section className={styles.buttonContainer}>
        <article className={`${styles.leftContainer} ${styles.buttons}`}>
          <DefaultButton onClick={() => setSubscriptionManageDomainsOpen(true)}>
            Manage domains
          </DefaultButton>
          <DefaultButton
            onClick={() => setSubscriptionRegisteredUserOpen(true)}
          >
            Registered users
          </DefaultButton>
          <DefaultButton onClick={() => setResetSubscriptionOpen(true)}>
            Reset subscription
          </DefaultButton>
          <DefaultButton onClick={() => setExtendSubscriptionOpen(true)}>
            Extend subscription
          </DefaultButton>
          <DefaultButton onClick={() => setChangeMaxUsersOpen(true)}>
            Change max users
          </DefaultButton>
        </article>
        <article className={`${styles.rightContainer} ${styles.buttons}`}>
          <DefaultButton
            className={styles.remove}
            onClick={() => setRemoveSubscriptionOpen(true)}
          >
            Cancel subscription
          </DefaultButton>
        </article>
      </section>
      {subscriptionManageDomainsOpen ? (
        <ManageDomains
          onCancel={() => setSubscriptionManageDomainsOpen(false)}
          onDone={() => {
            setSubscriptionManageDomainsOpen(false);
            props.onReload();
          }}
          subscription={props.subscription}
        />
      ) : null}
      {subscriptionRegisteredUserOpen ? (
        <RegisteredUsers
          subscription={props.subscription}
          onDone={() => {
            props.onReload();
            setSubscriptionRegisteredUserOpen(false);
          }}
          onReload={props.onReload}
        />
      ) : null}
      {removeSubscriptionOpen ? (
        <CancelSubscription
          onCancel={() => setRemoveSubscriptionOpen(false)}
          onDone={() => {
            setRemoveSubscriptionOpen(false);
            props.onReload();
          }}
          subscription={props.subscription}
        />
      ) : null}
      {extendSubscriptionOpen ? (
        <ExtendSubscription
          onCancel={() => setExtendSubscriptionOpen(false)}
          onDone={() => {
            setExtendSubscriptionOpen(false);
            props.onReload();
          }}
          subscription={props.subscription}
        />
      ) : null}
      {changeMaxUsersOpen ? (
        <ChangeMaxUsers
          onCancel={() => setChangeMaxUsersOpen(false)}
          onDone={() => {
            setChangeMaxUsersOpen(false);
            props.onReload();
          }}
          subscription={props.subscription}
        />
      ) : null}
      {resetSubscriptionOpen ? (
        <ResetSubscription
          onCancel={() => setResetSubscriptionOpen(false)}
          onDone={() => {
            setResetSubscriptionOpen(false);
            props.onReload();
          }}
          subscription={props.subscription}
        />
      ) : null}
    </article>
  );
};
